import React, { useState } from "react";
import {
  ActivityIndicator,
  Modal,
  StyleSheet,
  TouchableOpacity,
  View,
} from "react-native";
import { ImageZoom } from "@likashefqet/react-native-image-zoom";
import { GestureHandlerRootView } from "react-native-gesture-handler";

import ImageOptions, { ImageOptionAction } from "./UserImageOptions";

import { type UserImageMedia } from "@/schemas/user/image";

type ImageModalProps = {
  image: UserImageMedia;
  onOptionSelected: (action: ImageOptionAction) => void;
  allowedOptions: ImageOptionAction[];
};

function UserImageModal({
  image,
  onOptionSelected,
  allowedOptions,
}: ImageModalProps): React.JSX.Element {
  // GHRV is required on Android.
  // https://github.com/likashefqet/react-native-image-zoom?tab=readme-ov-file

  const [isLoading, setIsLoading] = useState(true);

  const onClose = (): void => {
    onOptionSelected(ImageOptionAction.CLOSE);
  };

  return (
    <Modal transparent={true}>
      <GestureHandlerRootView>
        <View style={styles.container}>
          <TouchableOpacity style={styles.imageContainer} onPress={onClose}>
            <ImageZoom
              uri={image.attributes.previewUrl}
              style={styles.image}
              onLoadStart={() => setIsLoading(true)}
              onLoad={() => setIsLoading(false)}
            />
            {isLoading && (
              <ActivityIndicator
                size="large"
                color="#ffffff"
                style={styles.loadingIndicator}
              />
            )}
          </TouchableOpacity>
          <View style={styles.close}>
            <ImageOptions
              onOptionSelected={(action: ImageOptionAction) =>
                onOptionSelected(action)
              }
              allowedOptions={allowedOptions}
            />
          </View>
        </View>
      </GestureHandlerRootView>
    </Modal>
  );
}

const styles = StyleSheet.create({
  loadingIndicator: {
    position: "absolute",
    alignSelf: "center",
  },
  close: {
    position: "absolute",
    right: 30,
    top: 50,
  },
  container: {
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    flex: 1,
    justifyContent: "center",
  },
  image: {
    height: "100%",
    resizeMode: "contain",
    width: "100%",
  },
  imageContainer: {
    alignItems: "center",
    height: "100%",
    justifyContent: "center",
    width: "100%",
  },
});

export default UserImageModal;
